<app-main-layout>
  <app-championship-directory-page></app-championship-directory-page>
</app-main-layout>
